export enum ECompanyStep {
  CompanyStartOnboarding = 'COMPANY_START_ONBOARDING',

  // Основная информация о компании
  CompanyBasicInfo = 'COMPANY_BASIC_INFO',
  CompanyRegisteredAddress = 'COMPANY_REGISTERED_ADDRESS',
  CompanyOperatingAddress = 'COMPANY_OPERATING_ADDRESS',
  CompanyBranchesCount = 'COMPANY_BRANCHES_COUNT',
  CompanyBusinessInfo = 'COMPANY_BUSINESS_INFO',
  CompanyRegistrantInfo = 'COMPANY_REGISTRANT_INFO',
  CompanyBusinessDescription = 'COMPANY_BUSINESS_DESCRIPTION',

  // Управление участниками
  CompanyMembersManagement = 'COMPANY_MEMBERS_MANAGEMENT',
  CompanyCorporateShareholders = 'COMPANY_CORPORATE_SHAREHOLDERS',

  // Источники богатства
  CompanyWealthSourcesSelection = 'COMPANY_WEALTH_SOURCES_SELECTION',
  CompanyWealthSourcesDetails = 'COMPANY_WEALTH_SOURCES_DETAILS',

  // Источники финансирования
  CompanyFundingSourcesSelection = 'COMPANY_FUNDING_SOURCES_SELECTION',

  // PEP (Politically Exposed Person) анкета
  CompanyPepQuestionnaireCheck = 'COMPANY_PEP_QUESTIONNAIRE_CHECK',
  CompanyPepInformation = 'COMPANY_PEP_INFORMATION',

  // Бизнес-платежи
  CompanyIncomingPayments = 'COMPANY_INCOMING_PAYMENTS',
  CompanyOutgoingPayments = 'COMPANY_OUTGOING_PAYMENTS',

  // Документы и верификация
  CompanyDocumentsSubmission = 'COMPANY_DOCUMENTS_SUBMISSION',
  CompanyDirectorsVerification = 'COMPANY_DIRECTORS_VERIFICATION',

  // Завершение
  CompanyOnboardingCompleted = 'COMPANY_ONBOARDING_COMPLETED',
}

export enum ECompanyAdditionalInfoKeys {
  // Основные шаги онбординга
  CompanyOnboardingStep = 'companyOnboardingStep',

  // Информация о филиалах
  CompanyBranchesWithinCountry = 'companyBranchesWithinCountry',
  CompanyBranchesOutsideCountry = 'companyBranchesOutsideCountry',

  // // Описание бизнеса
  // CompanyBusinessDescription = 'companyBusinessDescription',

  // Количество должностных лиц
  CompanyOfficersCount = 'companyOfficersCount',

  // Корпоративные акционеры
  CompanyHasCorporateShareholders = 'companyHasCorporateShareholders',

  // PEP (Politically Exposed Person) статус
  CompanyHasPepMembers = 'companyHasPepMembers',
}
